<template>
    <div v-if="currentUser.permissions.includes('admin.read')" class="px-16 px-md-60 pt-16 pt-md-32">
        <div class="row align-content-start">

            <div class="col-12 mb-24 small">
                <router-link class="text-dark d-flex" :to="{ name: 'admin-codes' }">
                    <i-back class="i-14 mr-16 fill-gold my-auto"></i-back>
                    {{ $t('general.back')}}
                </router-link>
            </div>

            <el-form @submit="submit" class="col-12 col-lg-8">

                <div class="row">
                    <div class="col-12">
                        <el-error class="mb-16" :error="server_error"></el-error>
                    </div>
                </div>

                <template slot="default">
                    <div class="row form-content">
                        <el-input class="col-12 col-md-6" v-model="data.first_name" :label="$t('form-elements.first_name')" name="first_name" :placeholder="$t('form-elements.first_name_placeholder')"></el-input>
                        <el-input class="col-12 col-md-6" v-model="data.last_name" :label="$t('form-elements.last_name')" name="last_name" :placeholder="$t('form-elements.last_name_placeholder')"></el-input>
                        <el-input class="col-12 col-md-6" :disabled="$route.name !== 'admin-create-admins'" v-model="data.email" type="email" :label="$t('form-elements.email')" name="email" :placeholder="$t('form-elements.email_placeholder')"></el-input>
                    </div>
                </template>

                <template slot="footer">
                    <div class="form-footer position-fixed px-lg-60">
                        <button type="submit" class="btn btn-primary btn-block btn-lg-inline d-block d-lg-flex" v-bind:class="{ disabled : loading }">
                            {{ $t('general.save') }}
                            <template v-if="loading">
                                <i-loader class="ml-2 i-20 my-auto"></i-loader>
                            </template>
                            <template v-if="success">
                                <i-check class="ml-2 i-20 my-auto"></i-check>
                            </template>
                        </button>
                    </div>
                </template>

            </el-form>

        </div>
    </div>
</template>

<script>
import { ElInput, ElError, ElForm } from '@/components/forms'

export default {
    components: { ElInput, ElError, ElForm },
    data: () => ({
        loading: false,
        success: false,
        server_error: null,
        update: false,

        data: {}
    }),

    mounted() {
        if (this.$route.name === 'admin-show-admins' && this.$route.params.id)
            this.$store.dispatch('admins/read', this.$route.params.id).then((admin) => {
                this.data = admin
                this.update = true
            })
    },
    methods: {
        submit() {

            this.$validator.validateAll().then(res => {
                if (res) {
                    this.loading = true
                    this.$store.dispatch(`admins/${!this.update ? 'create' : 'update'}`, this.data).then(
                        () => {
                            this.loading = false
                            this.success = true

                            this.$toasted.global.info({
                                title: this.$t('toasts.success_created_discount_code'),
                                description: this.$t('toasts.success_update_discount_code'),
                            });
                            setTimeout(() => {
                                this.success = false
                            }, 5000);
                        },
                        error => {
                            this.loading = false
                            this.success = false
                            this.server_error = error
                        }
                    )
                }
            })
        }
    },
    computed: {
        currentUser() {
            return this.$store.getters['user/currentUser']
        }
    }
}
</script>
